import React, { useState } from "react";
import Productdetailsleftcarousel from "./Productdetailsleftcarousel";
import StarRating from "./StarRating";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar, faStarHalfAlt } from "@fortawesome/free-solid-svg-icons";
import {
  faCartShopping,
  faShareNodes,
} from "@fortawesome/free-solid-svg-icons";
import { useDispatch } from "react-redux";
import Facebookicon from "../../assets/new-images/facebook-icon.png";
import Copyicon from "../../assets/new-images/copy-icon.png";
import Whatsappicon from "../../assets/new-images/whatsapp-icon.png";
import { Link, useNavigate } from "react-router-dom";
import { addToCart } from "../../features/cartSlice";
import "./productdetails.css";
import { FacebookShareButton, WhatsappShareButton } from "react-share";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { fetchCartItems } from "../../features/cartitemsSlice";
import { removeFromCart } from "../../features/cartSlice";
import { apiurl } from "../../Constants";
import axios from "axios";
function Singleproductdetails({
  overall_ratting,
  productDetails,
  relatedProducts,
}) {
  const [loading, setLoading] = useState(false);
  const [addedToCart, setAddedToCart] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user_id = localStorage.getItem("userId");

  const RatingStars = ({ rating }) => {
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;
    const totalStars = 5;

    return (
      <div className="ratings_two">
        {(() => {
          const stars = [];
          for (let i = 0; i < fullStars; i++) {
            stars.push(
              <FontAwesomeIcon
                key={i}
                icon={faStar}
                style={{ color: "#FFD700" }}
              />
            );
          }
          return stars;
        })()}

        {hasHalfStar && (
          <FontAwesomeIcon icon={faStarHalfAlt} style={{ color: "#FFD700" }} />
        )}

        {(() => {
          const emptyStars = [];
          for (
            let i = 0;
            i < totalStars - fullStars - (hasHalfStar ? 1 : 0);
            i++
          ) {
            emptyStars.push(
              <FontAwesomeIcon
                key={`empty-${i}`}
                icon={faStar}
                style={{ color: "#E0E0E0" }}
              />
            );
          }
          return emptyStars;
        })()}
      </div>
    );
  };

  const deleteCart = (product_id) => {
    dispatch(removeFromCart({ user_id, product_id }));
  };

  const updateCart = async (product_id, updatedQty) => {
    localStorage.removeItem("couponDetails");
    try {
      await axios.post(apiurl + "cart_quantity_update", {
        user_id: user_id,
        product_id: product_id,
        quantity: updatedQty,
      });
      dispatch(fetchCartItems(user_id));
    } catch (err) {
      console.error(err);
    } finally {
    }
  };

  const [quantity, setQuantity] = useState(1);

  const increaseQuantity = () => {
    if (quantity < productDetails.product_quantity) {
      setQuantity(quantity + 1);
    } else {
      toast.error(
        `Your Selected Order Quantity is Greater than our Existing Stock`
      );
    }
  };

  const decreaseQuantity = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    } else {
      toast.error(`You must purchase at least 1 of this product.`);
    }
  };

  const DecreaseQuantitys = (product_id, product_quantity) => {
    if (user_id) {
      const cartItems = cartitems.find((item) => item.id === product_id);

      if (cartItems) {
        var currentQty = cartItems.quantity;

        if (currentQty > 1) {
          const updatedQty = currentQty - 1;
          updateCart(product_id, updatedQty);
        } else {
          deleteCart(product_id);
        }
      }
    } else {
      navigate("/login");
    }
  };

  const IncreaseQuantitys = (product_id, product_quantity) => {
    if (user_id) {
      dispatch(fetchCartItems(user_id));

      const cartItems = cartitems.find((item) => item.id === product_id);

      if (cartItems) {
        var currentQty = cartItems.quantity;

        if (currentQty < product_quantity) {
          const updatedQty = currentQty + 1;
          updateCart(product_id, updatedQty);
        } else {
          toast.error(
            `Your Selected Order Quantity is Greater than Our Existing Stock`
          );
        }
      }
    } else {
      navigate("/login");
    }
  };

  const [sessionCart, setSessionCart] = useState(
    JSON.parse(sessionStorage.getItem("temp_cart")) || []
  );

  const handleAddToCart = (item) => {
    if (!user_id) {
      const tempCart = JSON.parse(sessionStorage.getItem("temp_cart")) || [];

      const newCart = [
        ...tempCart,
        {
          product_id: item.id,
          quantity: quantity,
        },
      ];

      sessionStorage.setItem("temp_cart", JSON.stringify(newCart));
      setSessionCart(newCart); // ✅ This triggers re-render
      return;
    }

    dispatch(addToCart({ user_id, product_id: item.id, quantity: quantity }))
      .then(() => {
        setLoading(false);
        setAddedToCart(true);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const Buynow = (item) => {
    if (!user_id) {
      navigate("/login");
    }

    dispatch(addToCart({ user_id, product_id: item.id, quantity: quantity }));

    navigate("/checkout-screen");
  };

  const [selectedProductIds, setSelectedProductIds] = useState([]);

  const handleCheckboxChange = (productId) => {
    setSelectedProductIds((prevSelected) => {
      if (prevSelected.includes(productId)) {
        // Remove the productId if already selected
        return prevSelected.filter((id) => id !== productId);
      } else {
        // Add the productId if not selected
        return [...prevSelected, productId];
      }
    });
  };

  const FrequentlyaddTocart = () => {
    if (!user_id) {
      navigate("/login");
      return;
    }

    if (selectedProductIds.length === 0) {
      alert("Please select at least one product to add to the cart.");
      return;
    }

    setLoading(true);

    // Dispatch addToCart for each selected product id
    Promise.all(
      selectedProductIds.map((productId) =>
        dispatch(addToCart({ user_id, product_id: productId, quantity: 1 }))
      )
    )
      .then(() => {
        setLoading(false);
        setAddedToCart(true);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const { items: cartitems } = useSelector((state) => state.cartitems);

  // const IsinCart = (product_id) =>
  //   cartitems?.find((cartdata) => cartdata.id === product_id) ? true : false;

  const IsinCart = (product_id) => {
    if (user_id) {
      return cartitems && cartitems.some((items) => items.id === product_id);
    } else {
      return sessionCart.some((item) => item.product_id === product_id);
    }
  };

  useEffect(() => {
    if (cartitems && productDetails?.id) {
      const cartItem = cartitems.find(
        (cartdata) => cartdata.id === productDetails.id
      );

      if (cartItem) {
        setQuantity(cartItem.quantity);
      }
    }
  }, [cartitems, productDetails?.id]);

  const [sliderSettingsrelatedproducts, setSlidersettinghgs] = useState({
    infinite: true,
    loop: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    margin: 8,
    nav: true,
    autoplay: true,
    dots: true,
    accessibility: true,
  });

  return (
    <section className="product_details_section_one pt-40 pb-40">
      <div className="container">
        <div className="row">
          <div className="col-lg-5 col-md-12 col-sm-12 image-col">
            <Productdetailsleftcarousel
              productsimage={productDetails.product_image}
              productDetails={productDetails}
            />
          </div>
          <div className="col-lg-7 col-md-12 col-sm-12 description-col">
            <div className="inner-box">
              <h3>{productDetails.product_name}</h3>
                <h5 className="bar_code mt-3"> Barcode: {productDetails.bar_code}</h5>
              <div className="row first-row">
                <div
                  className="inner_box"
                  style={{ display: "flex", gap: "10px", alignItems: "center" }}
                >
                  <div className="star-rating-col">
                    {productDetails.discount_price == 0 ? (
                      <h4>RM&nbsp;{productDetails.actual_price}</h4>
                    ) : (
                      <>
                        <h5>
                          <del
                            style={{
                              visibility:
                                productDetails.actual_price ===
                                productDetails.discount_price
                                  ? "hidden"
                                  : "visible",
                            }}
                          >
                            RM&nbsp; {productDetails.actual_price}
                          </del>
                        </h5>
                        <h4>RM&nbsp; {productDetails.discount_price}</h4>
                      </>
                    )}

                    <RatingStars rating={overall_ratting} />
                  </div>

                  <div className="share-link">
                    <div className="icon-box">
                      <FontAwesomeIcon icon={faShareNodes} />
                    </div>
                    <div className="social_icons">
                      <FacebookShareButton
                        url={`https://my.aammii.com/product-details/${productDetails.slug}`}
                        quote={productDetails.product_name}
                      >
                        <img src={Facebookicon} alt="Share on Facebook" />
                      </FacebookShareButton>

                      <WhatsappShareButton
                        url={`https://my.aammii.com/product-details/${productDetails.slug}`}
                        separator=":: " // Separator between the message and URL
                      >
                        <img src={Whatsappicon} alt="Share on WhatsApp" />
                      </WhatsappShareButton>
                      <span
                        onClick={() =>
                          navigator.clipboard.writeText(
                            `https://my.aammii.com/product-details/${productDetails.slug}`
                          )
                        }
                      >
                        <img src={Copyicon} alt="Copy URL" />
                      </span>
                    </div>
                  </div>
                </div>

                <div className="quantity-col mt-2 mb-2">
                  {productDetails.variant && productDetails.variant.length > 0
                    ? productDetails.variant.map((item, index) => {
                        return (
                          <React.Fragment key={index}>
                            {item.attribute_det &&
                            Object.keys(item.attribute_det).length > 0
                              ? Object.keys(item.attribute_det).map((key) => {
                                  return (
                                    <React.Fragment key={key}>
                                      {item.attribute_det[key].map(
                                        (size, sizeIndex) =>
                                          size.product_id != 0 ? (
                                            <Link
                                              to={`/product-details/${size.product_slug}`}
                                              style={{ textDecoration: "none" }}
                                              key={sizeIndex}
                                            >
                                              <div
                                                className={`rounded-box active ${
                                                  parseInt(size.product_id) ===
                                                  parseInt(productDetails.id)
                                                    ? "box_active"
                                                    : ""
                                                }`}
                                              >
                                                <span>{size.name}</span>
                                              </div>
                                            </Link>
                                          ) : (
                                            <React.Fragment>
                                              <Link
                                                className="rounded-box disabled"
                                                key={sizeIndex}
                                                style={{
                                                  pointerEvents: "none",
                                                  opacity: 0.4,
                                                  textDecoration: "none",
                                                }}
                                              >
                                                <span>{size.name}</span>
                                              </Link>
                                            </React.Fragment>
                                          )
                                      )}
                                    </React.Fragment>
                                  );
                                })
                              : null}
                          </React.Fragment>
                        );
                      })
                    : null}
                </div>

                <div className="button-box">
                  <div className="row">
                    <div className="col-lg-2 col-md-2 col-5 counter_col">
                      {productDetails.product_quantity === 0 ? (
                        <div className="out_of_stock text-center">
                          Out of Stock
                        </div>
                      ) : IsinCart(productDetails.id) ? (
                        <>
                          <div className="quantity-control">
                            <button
                              className="quantity-button"
                              onClick={() =>
                                DecreaseQuantitys(
                                  productDetails.id,
                                  productDetails.product_quantity
                                )
                              }
                            >
                              -
                            </button>
                            <div className="quantity-display">{quantity}</div>

                            <button
                              className="quantity-button"
                              onClick={() =>
                                IncreaseQuantitys(
                                  productDetails.id,
                                  productDetails.product_quantity
                                )
                              }
                            >
                              +
                            </button>
                          </div>
                        </>
                      ) : (
                        <>
                          {" "}
                          <div className="quantity-control">
                            <button
                              className="quantity-button"
                              onClick={() => decreaseQuantity()}
                              disabled={IsinCart(productDetails.id)}
                            >
                              -
                            </button>
                            <div className="quantity-display">{quantity}</div>

                            <button
                              className="quantity-button"
                              onClick={() => increaseQuantity()}
                              disabled={IsinCart(productDetails.id)}
                            >
                              +
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                    <div className="col-lg-5 col-md-5 col-sm-6 col-6">
                      {productDetails.product_quantity === 0 ? null : IsinCart(productDetails.id) ? (
                        <button
                          onClick={() => navigate("/cart")}
                          className="btn_1 go_to_cart_btn"
                          style={{ width: "100%" }}
                        >
                          Go to Cart
                        </button>
                      ) : (
                        <button
                          className="btn_1"
                          onClick={() => handleAddToCart(productDetails)}
                          style={{ width: "100%" }}
                        >
                          {loading ? (
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                          ) : (
                            "Add to Cart"
                          )}
                        </button>
                      )}
                    </div>
                    {/* <div className="col-lg-5 col-md-5 col-sm-6 col-6">
                      <button
                        className="pdbtn_2"
                        style={{ width: "100%" }}
                        onClick={() => Buynow(productDetails)}
                      >
                        <FontAwesomeIcon icon={faCartShopping} /> &nbsp; Buy Now
                      </button>
                    </div> */}
                  </div>
                </div>
                
              </div>
            </div>
            <div className="main-inner-box">
              <div className="inner-box-two">
                <p
                  className="mb-0"
                  dangerouslySetInnerHTML={{
                    __html: productDetails.short_description,
                  }}
                ></p>
              </div>

              {/* {productDetails.frequently_brought_together.length > 0 ? (
                <div className="inner-box-three frequently_bought_together">
                  <h5>Frequently bought together</h5>
                  <div className="row mt-4 justify-content-center">
                    {productDetails.frequently_brought_together.map(
                      (product, index) => {
                        const isProductInCart = cartitems.some(
                          (cartItem) => cartItem.id === product.id
                        );
                        return (
                          <React.Fragment key={product.id}>
                            <div style={{ width: "32%" }}>
                              <div className="card_inner_box">
                                  <div className="img_box">
                                    <img
                                      src={product.product_image}
                                      alt={product.product_name}
                                    />
                                    <div className="checkbox">
                                      <input
                                        type="checkbox"
                                        checked={
                                          selectedProductIds.includes(
                                            product.id
                                          ) || isProductInCart
                                        }
                                        onChange={() =>
                                          handleCheckboxChange(product.id)
                                        }
                                      />
                                    </div>
                                  </div>
                                
                                <div className="content_box">
                                  <p className="mb-0 text-center">
                                    <Link
                                      to={`/product-details/${product.slug}`}
                                      style={{
                                        textDecoration: "none",
                                        color: "inherit",
                                      }}
                                    >
                                      {" "}
                                      {product.product_name}
                                    </Link>
                                  </p>
                                  <h6 className="mb-0 text-center">
                                    RM{" "}
                                    {product.discount_price == 0
                                      ? product.actual_price
                                      : product.discount_price}
                                  </h6>
                                </div>
                              </div>
                            </div>

                            {index <
                              productDetails.frequently_brought_together
                                .length -
                                1 && (
                              <div
                                style={{ width: "1.5%", padding: "5px" }}
                                className="d-flex align-items-center justify-content-center"
                              >
                                <span className="plus-symbol">+</span>
                              </div>
                            )}
                          </React.Fragment>
                        );
                      }
                    )}
                  </div>
                  <div className="mt-3 text-center">
                    <button
                      className="btn_1"
                      onClick={FrequentlyaddTocart}
                      disabled={loading}
                    >
                      {loading ? "Adding..." : "Add"}
                    </button>
                  </div>
                </div>
              ) : null} */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Singleproductdetails;
